<template>
  <div>
    <div id="data-list-list-view" class="data-list-container mt-5">
      <div class="flex justify-center">
        <div>
          <vs-pagination :max="10" :total="transactions.last_page" v-model="transactions.current_page"></vs-pagination>
        </div>
      </div>

      <vs-table
        ref="table"
        noDataText="Nenhum item encontrado no período selecionado"
        :data="data"
        :sst="true"
        :stripe="true"
      >
        <template slot="thead">
          <vs-th>NÚMERO</vs-th>
          <vs-th>EMAIL</vs-th>
          <vs-th>VALOR</vs-th>
          <vs-th>SITUAÇÃO</vs-th>
          <vs-th>DATA</vs-th>
          <vs-th>HORA</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
            <vs-td :data="data[idx].number">
              {{ data[idx].number }}
            </vs-td>
            <vs-td :data="data[idx].affiliate.email ||''">
              {{ data[idx].affiliate.email }}
            </vs-td>
            <vs-td :data="data[idx].amount">{{ data[idx].amount | money(data[idx].currency) }}</vs-td>
            <vs-td :data="data[idx].status">{{ data[idx].status }}</vs-td>
            <vs-td :data="data[idx].created_at">{{ data[idx].created_at | formatDate }}</vs-td>
            <vs-td :data="data[idx].created_at">{{ data[idx].created_at | formatTime }}</vs-td>
            <vs-td :data="data[idx].status">
              <vs-button
                icon-pack="feather"
                icon="icon-dollar-sign"
                color="success"
                @click="markPayoutAsPaid(data, idx)"
                v-if="data[idx].status != 'Paga'"
              >Marcar Como Pago
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="flex justify-center">
        <div>
          <vs-pagination :max="10" :total="transactions.last_page" v-model="transactions.current_page"></vs-pagination>
        </div>
      </div>
    </div>

    <vs-prompt
      color="success"
      @accept="doMarkAsPaid"
      :active.sync="promptMarkAsPaid"
      accept-text="Marcar como Pago"
      cancel-text="Cancelar"
      title="Marcar como Pago"
    >
      <div class="mt-4">
        <label class="vs-input--label">E-mail: {{ payoutToMarkAsPaid.affiliate.email || '' }}</label>
      </div>
      <div class="mt-4">
        <label class="vs-input--label">Chave Pix: {{ payoutToMarkAsPaid.pix_key }}</label>
      </div>
      <div class="mt-4">
        <label class="vs-input--label">Valor: {{ payoutToMarkAsPaid.amount|money }}</label>
      </div>
      <div class="mt-4">
        <label class="vs-input--label">Comprovante: <input type="file" @change="uploadedFile"
                                                           accept="image/*,application/pdf" /></label>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  data() {
    return {
      transactions: {
        current_page: 1,
        last_page: 1
      },
      data: [],
      promptMarkAsPaid: false,
      payoutToMarkAsPaid: {
        affiliate: {}
      }
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.$vs.loading()

      this.$api
          .get('/api/v1/backend/affiliates/transactions', {
            params: {
              page: this.transactions.current_page,
            }
          })
          .then(response => {
            this.$vs.loading.close()
            this.data = response.data.data
            this.transactions = response.data
          })
    },
    markPayoutAsPaid(data, idx) {
      this.payoutToMarkAsPaid = data[idx]
      this.payoutToMarkAsPaid.idx = idx
      this.promptMarkAsPaid = true
    },
    uploadedFile(event) {
      this.payoutToMarkAsPaid.filename = event.target.files[0].name;

      const reader = new FileReader();
      reader.onload = (event) => {
        this.payoutToMarkAsPaid.file = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    },
    doMarkAsPaid() {
      this.$vs.loading()

      this.$api
          .post(`/api/v1/backend/affiliates/transactions/mark-as-paid`, this.payoutToMarkAsPaid)
          .then(() => {
            this.$vs.loading.close()

            this.payoutToMarkAsPaid =  {
              affiliate: {}
            }

            this.$vs.notify({
              text: 'Saque marcado como pago.',
              color: 'success'
            })

            this.load()
          })
          .catch((error) => {
            this.$vs.loading.close()

            this.promptMarkAsPaid = true

            let errors = []
            if (error.response.data.message) {
              errors.push(error.response.data.message)
            } else {
              for (const key in error.response.data) {
                if (Object.hasOwnProperty.call(error.response.data, key)) {
                  const element = error.response.data[key]
                  errors.push(element)
                }
              }
            }
            this.$vs.notify({
              time: 6000,
              text: errors.join('<br>'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })
    },
  },

  watch: {
    'transactions.current_page'() {
      this.load()
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          bg-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
